import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  Mall,
  GetOrderSheetsOrderSheetNoRequest,
  GetShippingAddressesRecentRequest,
  GetManualOrderProductsRequest,
  GetAccumulationConfigurationsRequest,
  GetOrderSheetsOrderSheetNo,
  AgreementTermsAgree,
  CustomTermsAgree,
} from 'supporter';
import { MallsArrItem } from '@/types';
import { ncpPopup } from '@/utils/commonUtils';
import { ValueNameType } from '@/store/modules/orderEnums';
import { getCookie } from '@/pro/utils/cookie';
import { SHOPBY_ACCESSTOKEN } from '@/const/words/cookie';
import { throwWindowPopup } from '@/pro/helpers/popup';

const orderEnumsModule = namespace('orderEnums');
const mallModule = namespace('mall');

@Component
export default class ManualOrder extends Vue {
  @mallModule.Getter('mallsGlobalExceptSubMall')
  public malls!: Mall[];
  @orderEnumsModule.Getter('pgTypeMap')
  private readonly pgTypeMap!: ValueNameType[];

  public theMalls: MallsArrItem[] = [];
  public mallNOsArr: any[] = [];
  public selectMall: any = {
    mallNo: undefined,
  };
  public beforeMallNo: any = null;
  public memberType: any = 'MEMBER';
  public memberNo: any = 0;
  public PRODUCT_COUNT_LIMIT: any = 30;
  public emptyFlag: boolean = true;
  public productListContent: any = [];
  public addProductNos: any = null;

  public phoneNum1: any = '010';
  public phoneNum2: any = '';
  public phoneNum3: any = '';
  public phoneNumsArr: any = [
    { value: '010', option: '010' },
    { value: '011', option: '011' },
    { value: '016', option: '016' },
    { value: '017', option: '017' },
    { value: '018', option: '018' },
    { value: '019', option: '019' },
  ];
  public emailName: any = '';
  public emailDomain: any = '';
  public emailError: boolean = false;
  public emailErrorText: string = '';
  public defaultDomain: any = {
    value: undefined,
  };
  public defaultDomainsArr: any = [
    { value: 'naver.com', option: 'naver.com' },
    { value: 'hanmail.net', option: 'hanmail.net' },
    { value: 'daum.net', option: 'daum.net' },
    { value: 'hotmail.com', option: 'hotmail.com' },
    { value: 'nate.com', option: 'nate.com' },
    { value: 'gmail.com', option: 'gmail.com' },
  ];

  public contactError: boolean = false;
  public contact2: any = '';
  public contact1: any = '010';
  public contact3: any = '';
  public contactTwo1: any = '';
  public contactTwo2: any = '';
  public contactTwo3: any = '';
  public deliveryMemoArr: any = [
    { value: '배송 전에 미리 연락 바랍니다.', option: '배송 전에 미리 연락 바랍니다.' },
    { value: '부재 시 경비실에 맡겨 주세요.', option: '부재 시 경비실에 맡겨 주세요.' },
    { value: '부재 시 연락 바랍니다.', option: '부재 시 연락 바랍니다.' },
    { value: '택배함에 넣어주세요.', option: '택배함에 넣어주세요.' },
    { value: '문앞에 놓아주세요.', option: '문앞에 놓아주세요.' },
  ];
  public deliveryMemo: any = {
    value: undefined,
  };
  public writeMomo: boolean = false;
  public deliveryMemoWrite: any = '';
  public requireCustomsId: boolean = false;
  public requireCustomsIdHelp: boolean = false;
  public paymentData: any = {};

  // "현재 수기주문정책 기준"으로 payType은 무통장입금/가상계좌만 사용가능함.
  // "현재 코드기준"으로는 가상계좌만 사용가능함. 무통장입금은 개발이 막힌상태. 무통장입금도 사용가능해지면 아래배열에 추가해야함.
  private enablePayTypesInManualOrder = [{ value: 'VIRTUAL_ACCOUNT', name: '가상계좌' }];
  // enablePayTypesInManualOrder과 같은 맥락에서, 가상계좌 결제가 가능한 PG는 아래와 같음.
  private enablePgTypesForManualOrder = ['KCP', 'INICIS', 'TOSS_PAYMENTS', 'NICEPAY', 'SMARTRO_PAY', 'EASY_PAY', 'EASY_PAY_OVERSEAS', 'GALAXIA_MONEY_TREE', 'KSNET', 'BLUE_WALNUT'];

  public payType = this.enablePayTypesInManualOrder[0].value;
  public pgType = '';

  public payTypes = this.enablePayTypesInManualOrder; // 나중에 정책이 변경될 수 있으므로, enablePayTypesInManualOrder를 별도로 만들고 값을 연결해둠.
  public pgTypes = [];

  public searchProductDisabled: boolean = true;
  public avaliableCouponCount: any = 0;
  public theOrderSheetNo: any = '';
  public applyData: any = {};
  public accumulationAmt: any = null;
  public receiverInfoContent: any = [];
  public orderInfo: any = {};
  public showInfo: boolean = false;
  public receiverNameTap: boolean = false;
  public receiverInfo: any = {};
  public typeAddress: string = 'new';
  public choseReceiverNameNo: any = '';
  public choseReceiverindex: any = 0;
  public couponRequest: any = {
    cartCouponIssueNo: 0,
    deliveryCouponIssueNo: 0,
    productCoupons: [],
  };
  public theOrdererName: any = '';
  public discountCouponAmt: any = 0;
  public accumulationAmtError: boolean = false;
  public removeAllCheckbox: boolean = false;
  public showListView: boolean = false;
  public accumulationInfoData: any = [];
  public theAccumulationName: any = '';
  public theAccumulationUnit: any = '';
  public productListView: any = [];
  public freeGiftInfos = [];
  public theOrderTitle: any = '';
  public payplusScript: any = null;
  public iNIStdPayScript: any = null;
  public confirmUrl: any = '';

  public handleSaveOrder(): void {}

  public formatterContact(item: any): void {
    if (item) {
      if (item.receiverContact1) {
        this.contact1 = item.receiverContact1.split('-')[0];
        this.contact2 = item.receiverContact1.split('-')[1];
        this.contact3 = item.receiverContact1.split('-')[2];
      }

      if (item.receiverContact2) {
        if (item.receiverContact2.split('-').length > 0) {
          this.contactTwo1 = item.receiverContact2.split('-')[0];
        }
        if (item.receiverContact2.split('-').length > 1) {
          this.contactTwo2 = item.receiverContact2.split('-')[1];
        }
        if (item.receiverContact2.split('-').length > 2) {
          this.contactTwo3 = item.receiverContact2.split('-')[2];
        }
      }
    }
  }
  /////////////////////////////////////////////////////////SET_confirmUrl/////////////////////////////////////////////////////////////////
  public createKcpForm(): any {
    const form = document.createElement('form');
    form.id = 'confirm_info';
    form.method = 'post';
    form.innerHTML = `
                <input type='hidden' name='req_tx' value='pay'/>
                <input type='hidden' name='quotaopt' value=''/>
                <input type='hidden' name='currency' value=''/>
                <input type='hidden' name='module_type'     value='01'/>
                <input type='hidden' name='res_cd'          value=''/>
                <input type='hidden' name='res_msg'         value=''/>
                <input type='hidden' name='enc_info'        value=''/>
                <input type='hidden' name='enc_data'        value=''/>
                <input type='hidden' name='ret_pay_method'  value=''/>
                <input type='hidden' name='tran_cd'         value=''/>
                <input type='hidden' name='use_pay_method'  value=''/>
                <input type='hidden' name='ordr_chk'        value=''/>
                <input type='hidden' name='cash_yn'         value=''/>
                <input type='hidden' name='cash_tr_code'    value=''/>
                <input type='hidden' name='cash_id_info'    value=''/>
                <input type='hidden' name='good_expr' value='0'>
                <input type='hidden' name='platformType' value='PC'>
                `;
    document.body.appendChild(form);
    return form;
  }
  public setWindowFn(): void {
    (window as any).m_Completepayment = (FormOrJson: any, closeEvent: any): any => {
      const confirmURL = this.confirmUrl;
      const frm = this.createKcpForm();
      (window as any).GetField(frm, FormOrJson);
      if (frm.res_cd.value === '0000') {
        frm.action = confirmURL;
        frm.submit();
      } else {
        window.alert(`[${frm.res_cd.value}] ${frm.res_msg.value}`);
        closeEvent();
      }
    };
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public handleTextArea(ev: any): void {
    this.addProductNos = ev.target.value.replace(/[^\d,]/g, '');
  }
  ////////////////////////////////////////////////////SET- PAYMENT-POP////////////////////////////////////////////////////////
  public clickPaymentBtn(): void {
    if (!this.theOrdererName) {
      $('input[name=ordererName]').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_1'));
      return;
    }
    if (!this.phoneNum2 || this.phoneNum2.length < 3) {
      $('#ordererContact1Two').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_2'));
      return;
    }
    if (!this.phoneNum3 || this.phoneNum3.length < 4) {
      $('#ordererContact1Three').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_2'));
      return;
    }
    if (!this.emailName || this.emailError) {
      $('#emailName').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_3'));
      return;
    }
    if (!this.emailDomain || this.emailError) {
      $('#emailDomain').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_3'));
      return;
    }
    if (!this.receiverInfoContent[0].receiverName) {
      $('#receiverName').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_4'));
      return;
    }
    if (!this.receiverInfoContent[this.choseReceiverindex].receiverZipCd) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_5'));
      return;
    }
    if (!this.receiverInfoContent[this.choseReceiverindex].receiverAddress) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_4'));
      return;
    }
    if (!this.contact2 || this.contact2.length < 3) {
      $('#receiverContact1Two').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_6'));
      return;
    }
    if (!this.contact3 || this.contact3.length < 3) {
      $('#receiverContact1Three').focus();
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_6'));
      return;
    }
    if (this.requireCustomsId) {
      if (
        !this.receiverInfoContent[this.choseReceiverindex].customsIdNumber ||
        !this.validateCustomsIdNumber(this.receiverInfoContent[this.choseReceiverindex].customsIdNumber)
      ) {
        $('#customsIdNumber').focus();
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_7'));
        return;
      }
    }
    if (!this.receiverInfoContent[this.choseReceiverindex].receiverDetailAddress) {
      if (!confirm(this.$t('ORDER_MANUAL_ORDER_CONFIRM_2') as any)) {
        return;
      }
    }
    // post api
    const reserveRequest: any = this.initReserveRequest();

    window.NCPPay.setConfiguration({
      accessToken: getCookie(SHOPBY_ACCESSTOKEN),
      platform: 'PC',
    });

    window.NCPPay.reservation(reserveRequest.data, (data) => this.confirmUrl = data.confirmUrl);

    // 아래 handlePgPayType는 기존에 PG결제를 위해 사용하던 로직이다. KCP / 이니시스에 대해 작성되어있는데, 어드민용 PG결제모듈이 완성되면 통채로 삭제예정.
    // 히스토리 파악을 위해 사용될지모르니 일단 살려둠
    // this.handlePgPayType(res.data.pgType, res.data);
  }

  public initReserveRequest(): void {
    //shippingAddress
    const request: any = {
      data: {},
    };
    const shippingAddress: any = {};
    this.$set(shippingAddress, 'receiverAddress', this.receiverInfoContent[this.choseReceiverindex].receiverAddress);
    this.$set(
      shippingAddress,
      'receiverJibunAddress',
      this.receiverInfoContent[this.choseReceiverindex].receiverJibunAddress,
    );
    this.$set(shippingAddress, 'addressNo', this.receiverInfoContent[this.choseReceiverindex].addressNo);
    this.$set(shippingAddress, 'receiverName', this.receiverInfoContent[this.choseReceiverindex].receiverName);
    this.$set(shippingAddress, 'customsIdNumber', this.receiverInfoContent[this.choseReceiverindex].customsIdNumber);
    this.$set(shippingAddress, 'countryCd', this.receiverInfoContent[this.choseReceiverindex].countryCd);
    this.$set(shippingAddress, 'addressName', this.receiverInfoContent[this.choseReceiverindex].addressName);
    this.$set(shippingAddress, 'receiverZipCd', this.receiverInfoContent[this.choseReceiverindex].receiverZipCd);
    this.$set(
      shippingAddress,
      'receiverDetailAddress',
      this.receiverInfoContent[this.choseReceiverindex].receiverDetailAddress,
    );
    this.$set(shippingAddress, 'receiverContact1', this.receiverInfoContent[this.choseReceiverindex].receiverContact1);
    this.$set(shippingAddress, 'receiverContact2', this.receiverInfoContent[this.choseReceiverindex].receiverContact2);
    this.$set(request.data, 'shippingAddress', shippingAddress);
    // orderer
    const orderer: any = {};
    const phoneNums: any = this.phoneNum1 + '-' + this.phoneNum2 + '-' + this.phoneNum3;
    this.$set(orderer, 'ordererEmail', this.emailName + '@' + this.emailDomain);
    this.$set(orderer, 'ordererContact1', phoneNums);
    this.$set(orderer, 'ordererContact2', '');
    this.$set(orderer, 'ordererName', this.theOrdererName);
    this.$set(request.data, 'orderer', orderer);
    // coupons
    this.$set(request.data, 'coupons', this.couponRequest);
    // orderTitle
    this.$set(request.data, 'orderTitle', this.theOrderTitle);
    // subPayAmt
    this.$set(request.data, 'subPayAmt', Number(this.accumulationAmt && this.accumulationAmt.replace(/,/g, '')) || 0);
    // member
    this.$set(request.data, 'member', this.memberType === 'MEMBER' ? true : false);
    // deliveryMemo
    if (this.writeMomo) {
      this.$set(request.data, 'deliveryMemo', this.deliveryMemoWrite);
    } else {
      this.$set(request.data, 'deliveryMemo', this.deliveryMemo.value);
    }
    //useDefaultAddress
    if (this.typeAddress === 'new') {
      this.$set(request.data, 'useDefaultAddress', false);
    } else {
      this.$set(request.data, 'useDefaultAddress', true);
    }

    if(this.freeGiftInfos.length > 0) {
      const freeGiftInfos = this.freeGiftInfos.reduce((acc, group) => {
        const checkedFreeGifts = group.freeGifts.filter((item) => item.checked);

        if(!!checkedFreeGifts.length) {
          return [...acc, {
            freeGiftConditionNo: group.freeGiftConditionNo,
            freeGifts: checkedFreeGifts.map((item) => ({
              mallOptionNo: item.mallOptionNo,
              mallProductNo: item.mallProductNo,
            })),
          }]
        }
        
        return acc;
      }, []);
      this.$set(request.data, 'freeGiftInfos', freeGiftInfos);
    }

    const host: any = (window as any).origin;
    request.data.clientReturnUrl = `${host}/order/manual-order/confirm`;

    // pg가 설정되지 않은 경우에도 적립금 결제가 가능하도록 개선
    const payable = !Number(this.paymentData.paymentAmt) && !this.pgType;
    request.data.pgType = payable ? 'NONE' : this.pgType;
    request.data.payType = this.payType;
    request.data.orderSheetNo = this.theOrderSheetNo;
    request.data.agreementTermsAgrees = this.orderInfo.termsInfos.map(({ termsType, required }): AgreementTermsAgree => ({ isAgree: required, termsType }))
    request.data.customTermsAgrees = this.orderInfo.customTermsInfos.map(({ customTermsNo, required }): CustomTermsAgree => ({ isAgree: required, customTermsNo }));

    return request;
  }
  closeInicis() {}
  public handlePgPayType(pgType: any, reserveResponse: any): void {
    const { extraData } = reserveResponse;
    if (pgType === 'INICIS') {
      const element = document.querySelector('#inicisIframe');
      if (element) {
        element.parentNode.removeChild(element);
      }
      const orderSheetNo = encodeURIComponent(reserveResponse.orderSheetNo);
      const iframeUrl = `${process.env.VUE_APP_INICIS_IFRAME_URL}?orderSheetNo=${orderSheetNo}`;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML =
        '<iframe frameborder="0" scrolling="no" allowtransparency="true" id="inicisIframe" style="border: none; margin: 0px; padding: 0px;position: fixed;top: 0;left: 0;z-index: 999;width: 100%;height: 100%;">';
      document.body.appendChild(tempDiv.firstChild);
      document.querySelector('#inicisIframe').setAttribute('src', iframeUrl);
      window.addEventListener('message', this.closeInicis, false);
    } else if (pgType === 'KCP') {
      let $form = $('#kcpForm');
      const formAttr = {
        id: 'kcpForm',
        method: 'POST',
      };
      if ($form.length < 1) {
        $form = $('<form/>').attr(formAttr);
      } else {
        $form.empty();
      }

      for (const key in extraData) {
        if (extraData[key] !== null) {
          const attr = {
            type: 'hidden',
            name: key,
            value: extraData[key],
          };
          $('<input/>')
            .attr(attr)
            .appendTo($form);
        }
      }

      const attr = {
        type: 'hidden',
        name: 'disp_tax_yn',
        value: 'Y',
      };
      $('<input/>')
        .attr(attr)
        .appendTo($form);
      $('body').append($form);
      (window as any).KCP_Pay_Execute($form[0]); // payplus_web.jsp가 선언한 함수
    } else if (!pgType) {
      return;
    }
  }
  //////////////////////////////////////////////SET- accumulation////////////////////////////////////////////////////////////
  public getAccumulationInfo(): void {
    const request: GetAccumulationConfigurationsRequest = {
      params: {
        mallNo: this.selectMall.mallNo,
      },
    };
    this.$api.getAccumulationsConfigurations(request).then((res: any): any => {
      this.accumulationInfoData = [];
      this.accumulationInfoData = res.data;
      this.theAccumulationName = this.accumulationInfoData[0].basic.accumulationName;
      this.theAccumulationUnit = this.accumulationInfoData[0].basic.accumulationUnit;
    });
  }

  ////////////////////////////////////////// SET- productList////////////////////////////////////////////////
  public returnOptionTxt(tag: any): any {
    let txt: any = '';
    if (tag === 'PRODUCT') {
      txt = this.$t('ORDER_MANUAL_ORDER_OPTION_TEXT_PRODUCT');
    } else if (tag === 'OPTION') {
      txt = this.$t('ORDER_MANUAL_ORDER_OPTION_TEXT_OPTION');
    }
    return txt;
  }

  public productCallBack(res: any): void {
    const mallProductNos: any = res
      .map((item: any): any => {
        return item.mallProductNo;
      })
      .join(',');

    this.getProductList(mallProductNos);
  }
  public getProductList(mallProductNos: any): void {
    const request: GetManualOrderProductsRequest = {
      params: {
        productNos: mallProductNos,
        memberNo: this.memberNo,
      },
    };
    this.$api.getManualOrderProducts(request).then((res: any): any => {
      if (!this.checkProductListExist(res.data)) {
        return;
      }
      this.formatterProductListContent(this.productListContent);
      this.productListContent = [...this.handleFirstLine(this.productListContent)];
      this.emptyFlag = false;
    });
  }
  public checkProductListExist(arr: any): any {
    // 商品号码和状态无效。确认后请登记
    if (arr.length === 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_8'));
      return false;
    }
    const manualMallProducts: any = arr.filter(
      (product: any): any => product.saleStatusType === 'ON_SALE' || product.saleStatusType === 'ON_PRE_SALE',
    );
    if (manualMallProducts.length === 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_8'));
      return false;
    }

    let num: any = 0;
    if (this.productListContent.length === 0) {
      if (manualMallProducts.length > 30) {
        // 检查是否超过30条
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_27'));
        return false;
      } else {
        this.productListContent = [...manualMallProducts];
        num = manualMallProducts.length;
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_9', { num: num }));
      }
    } else {
      // 检查是否超过30条
      const theAddItem: any = [];
      manualMallProducts.map((item: any): any => {
        const productNos: any = this.productListContent.filter((pItem: any): any => {
          return item.productNo === pItem.productNo;
        }).length;
        if (productNos === 0) {
          theAddItem.push(item);
        }
      });
      const productNos: any = [];
      this.productListContent.map((pItem: any): any => {
        if (productNos.indexOf(pItem.productNo) < 0) {
          productNos.push(pItem.productNo);
        }
      });

      if (productNos.length + theAddItem.length > 30) {
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_27'));
        return false;
      }
      //
      const addItemArr: any = [];
      manualMallProducts.map((item: any): any => {
        const productNos: any = this.productListContent.filter((pItem: any): any => {
          return item.productNo === pItem.productNo;
        }).length;
        if (productNos === 0) {
          this.productListContent.push(item);
          addItemArr.push(item);
        }
      });
      if (addItemArr.length === 0) {
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_10'));
        return false;
      } else {
        const nums: any = addItemArr.length;
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_11', { nums: nums }));
      }
    }
    return true;
  }
  public formatterProductListContent(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      this.$set(item, 'totalBuyAmt', 0);
      this.$set(item, 'stockArr', [0]);
      item.options.map((oItem: any): any => {
        if (!oItem.stock) {
          this.$set(oItem, 'disabledV', true);
        } else {
          const stockArr: any = [];
          // 제한없이 렌더링 시 브라우저가 뻗을 수 있어서 최대 100로 제한
          for (let i = 1; i <= Math.min(oItem.stock, 100); i++) {
            stockArr.push(i);
          }
          this.$set(oItem, 'stocks', stockArr);
        }
      });
      if (!item.selectStockCnt) {
        item.selectStockCnt = 0;
      }
    });
    arr.map((item: any): any => {
      if (item.select) {
        this.productListContent.map((item1: any): any => {
          if (item1.productNo === item.productNo) {
            item1.options.map((oItem: any): any => {
              if (oItem.optionNo === item.select) {
                this.$set(item, 'stockArr', oItem.stocks);
              }
            });
          }
        });
      }
    });
  }
  public handleSelectChange(data: any): any {
    if (data.select === undefined) {
      this.$set(data, 'stockArr', [0]);
      data.selectStockCnt = 0;
      data.buyPrice = 0;
      data.totalBuyAmt = 0;
    }
    if (data.select) {
      this.productListContent.map((item: any): any => {
        if (item.productNo === data.productNo) {
          item.options.map((oItem: any): any => {
            if (oItem.optionNo === data.select) {
              this.$set(data, 'stockArr', oItem.stocks);
              data.selectStockCnt = 1;
              this.$set(data, 'optionV', oItem.optionValue);
              this.$set(data, 'optionN', oItem.optionName);
              data.buyPrice = oItem.purchasePrice;
              this.$set(data, 'totalBuyAmt', oItem.purchasePrice);
            }
          });
        }
      });
    }
    this.handleAllBuyAmt(data);
  }

  public handleAmt(data: any): any {
    let total: any = 0;
    total = data.buyPrice * Number(data.selectStockCnt);
    this.productListContent.map((item: any): any => {
      if (item === data) {
        this.$set(item, 'totalBuyAmt', total);
      }
    });
    this.handleAllBuyAmt(data);
  }
  public handleAllBuyAmt(data): void {
    let allTotal: any = 0;
    this.productListContent.map((item: any): any => {
      if (item.productNo === data.productNo) {
        allTotal += Number(item.totalBuyAmt);
      }
    });
    this.productListContent.map((item: any): any => {
      if (item.productNo === data.productNo && item.firstLine) {
        this.$set(item, 'AllTotalBuyAmt', allTotal.toLocaleString());
      }
    });
  }
  public handleAddList(theItem: any): void {
    let addIndex: any = 1;
    this.productListContent.map((item: any, index: any): any => {
      if (item.productNo === theItem.productNo) {
        addIndex = index;
      }
    });
    const obj: any = JSON.parse(JSON.stringify({ ...theItem }));

    this.productListContent.splice(addIndex + 1, 0, obj);
    this.productListContent.map((item: any, index: any): any => {
      this.$set(item, 'check', false);
      this.$set(item, 'checkAll', false);
      if (index === addIndex + 1) {
        this.$set(item, 'select', undefined);
        this.$set(item, 'stockArr', [0]);
        this.$set(item, 'selectStockCnt', 0);
        this.$set(item, 'buyPrice', 0);
        this.$set(item, 'totalBuyAmt', 0);
      }
    });

    this.productListContent = [...this.handleFirstLine(this.productListContent)];
  }
  public handleFirstLine(arr: any): any {
    if (arr.length === 0) {
      return;
    }
    const groupArr: any = [];
    arr.map((item: any): any => {
      this.$set(item, 'firstLine', false);
      this.$set(item, 'theRow', null);
      if (groupArr.indexOf(item.productNo) < 0) {
        this.$set(item, 'firstLine', true);
        groupArr.push(item.productNo);
        const row: any = arr.filter((theItem: any): any => {
          return item.productNo === theItem.productNo;
        }).length;
        this.$set(item, 'theRow', row);
      }
    });
    return arr;
  }
  public handleCheckChange(data: any, tag?: string): void {
    if (tag === 'all') {
      this.productListContent.map((item: any): any => {
        if (data.productNo === item.productNo) {
          if (data.checkAll) {
            item.check = true;
          } else {
            item.check = false;
          }
        }
      });
    } else {
      this.productListContent.map((item: any): any => {
        if (item.productNo === data.productNo && item.firstLine) {
          if (!data.check) {
            item.checkAll = false;
          } else {
            const checkFalse: any = this.productListContent.filter((pItem: any): any => {
              return pItem.productNo === data.productNo && !pItem.check;
            });
            if (checkFalse.length === 0) {
              item.checkAll = true;
            }
          }
        }
      });
    }
    // removeAllCheckbox
    const removeAll: any = this.productListContent.filter((item: any): any => {
      return !item.check;
    });
    if (removeAll.length === 0) {
      this.removeAllCheckbox = true;
    } else {
      this.removeAllCheckbox = false;
    }
  }
  public handleRemoveProductList(): void {
    this.removeAllCheckbox = false;

    if (this.productListContent.length === 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_12'));
      return;
    }
    const checks: any = this.productListContent.filter((item: any): any => {
      return item.check;
    });
    if (checks.length === 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_12'));
      return;
    }
    if (checks.length && !confirm(this.$t('ORDER_MANUAL_ORDER_CONFIRM_3') as any)) {
      return;
    }
    this.productListContent = this.productListContent.filter((item: any): any => {
      return !item.check;
    });
    this.productListContent = [...this.handleFirstLine(this.productListContent)];
    this.removeListCalculateTotalAmt();
  }
  public removeListCalculateTotalAmt(): void {
    if (this.productListContent.length === 0) {
      return;
    }
    const productNos: any = [];
    this.productListContent.map((item: any): any => {
      if (productNos.indexOf(item.productNo) < 0) {
        productNos.push(item.productNo);
      }
    });
    productNos.map((pn: any): any => {
      let allAmt: any = 0;
      this.productListContent.map((pItem: any): any => {
        if (pn === pItem.productNo) {
          allAmt += pItem.totalBuyAmt;
        }
      });
      this.productListContent.map((item: any): any => {
        if (item.firstLine && item.productNo === pn) {
          item.AllTotalBuyAmt = allAmt.toLocaleString();
        }
      });
    });
  }
  ///////////////////////////////////click receiveList///////////////////////////////////////
  public choseReceiveList(no: any): void {
    this.choseReceiverNameNo = no;
  }
  ///////////////////////////////////calculate///////////////////////////////////////
  public checkInput(): void {
    const regxp: any = /[^\d]/g;
    if (regxp.test(this.accumulationAmt)) {
      this.accumulationAmtError = true;
    } else {
      this.accumulationAmtError = false;
    }
    this.accumulationAmt = this.accumulationAmt.replace(/[^\d]/g, '');
  }
  public checkTheAccumulationAmt(): any {
    this.accumulationAmtError = false;
    const inputAmt: any = this.accumulationAmt.replace(/,/g, '');
    const maxAmt: any = this.paymentData.availableMaxAccumulationAmt.replace(/,/g, '');
    if (Number(inputAmt) > Number(maxAmt)) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_13'));
      this.accumulationAmt = 0;
    }
    // 적립금 blur이벤트 발생시, calculate호출
    this.calculateAmount();
  }
  public handleAccumultaion(): void {
    //之后查看
    if (!Number(this.paymentData.availableMaxAccumulationAmt.replace(/,/g, ''))) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_14', { name: this.theAccumulationName }));
    }

    if (Number(this.accumulationAmt) === 0 || Number(this.accumulationAmt.replace(/,/g, '') || 0) > Number(this.paymentData.availableMaxAccumulationAmt.replace(/,/g, ''))) {
      this.accumulationAmt = this.paymentData.availableMaxAccumulationAmt;
    }
    this.calculateAmount();
  }
  public calculateOrderSheetAmountFromCouponPopup(data: any): any {
    this.couponRequest = {};
    this.couponRequest = data.appliedCoupons;
    this.applyData = data;
    this.accumulationAmt = 0;
    this.calculateAmount();
  }

  public calculateAmount(): void {
    const calculateRequest: any = {
      pathParams: {
        orderSheetNo: this.theOrderSheetNo,
      },
      data: {},
    };
    if (this.receiverInfoContent[this.choseReceiverindex]) {
      calculateRequest.data.addressRequest = this.receiverInfoContent[this.choseReceiverindex]
    }
    this.initCalculateRequest(calculateRequest);
    this.$api.postOrderSheetsOrderSheetNoCalculate(calculateRequest).then((res: any): any => {
      this.discountCouponAmt = (
        Number(res.data.paymentInfo.productCouponAmt) +
        Number(res.data.paymentInfo.cartCouponAmt) +
        Number(res.data.paymentInfo.deliveryCouponAmt)
      ).toLocaleString();
      this.handleGetPaymentData(res.data);
      
      const checkedMap = new Map<number, Set<number>>();

      this.freeGiftInfos?.forEach(info => {
        const checkedProducts = info.freeGifts
          .filter(gift => gift.checked)
          .map(gift => gift.mallProductNo);

        if (checkedProducts.length > 0) {
          checkedMap.set(info.freeGiftConditionNo, new Set(checkedProducts));
        }
      });

      this.freeGiftInfos = res.data.freeGiftInfos.map((item) => ({
        ...item,
        freeGifts: item.freeGifts.map((gift) => ({
          ...gift,
          checked: checkedMap.get(item.freeGiftConditionNo)?.has(gift.mallProductNo) || false,
        })),
      }));
    });
  }

  public initCalculateRequest(request: any): void {
    //accumulationUseAmt
    this.$set(
      request.data,
      'accumulationUseAmt',
      this.accumulationAmt ? Number(this.accumulationAmt.replace(/,/g, '')) : 0,
    );

    //addressRequest
    const addressRequest: any = {};
    this.$set(addressRequest, 'receiverAddress', this.receiverInfoContent[this.choseReceiverindex].receiverAddress);
    this.$set(
      addressRequest,
      'receiverJibunAddress',
      this.receiverInfoContent[this.choseReceiverindex].receiverJibunAddress,
    );
    this.$set(addressRequest, 'defaultYn', this.receiverInfoContent[this.choseReceiverindex].defaultYn);
    this.$set(addressRequest, 'addressType', this.receiverInfoContent[this.choseReceiverindex].addressType);
    this.$set(addressRequest, 'receiverName', this.receiverInfoContent[this.choseReceiverindex].receiverName);
    this.$set(addressRequest, 'customsIdNumber', this.receiverInfoContent[this.choseReceiverindex].customsIdNumber);
    this.$set(addressRequest, 'countryCd', this.receiverInfoContent[this.choseReceiverindex].countryCd);
    this.$set(addressRequest, 'receiverZipCd', this.receiverInfoContent[this.choseReceiverindex].receiverZipCd);
    this.$set(addressRequest, 'addressName', this.receiverInfoContent[this.choseReceiverindex].addressName || '');
    this.$set(
      addressRequest,
      'receiverDetailAddress',
      this.receiverInfoContent[this.choseReceiverindex].receiverDetailAddress,
    );
    this.$set(addressRequest, 'receiverContact1', this.receiverInfoContent[this.choseReceiverindex].receiverContact1);
    this.$set(addressRequest, 'receiverContact2', this.receiverInfoContent[this.choseReceiverindex].receiverContact2);

    this.$set(request.data, 'addressRequest', addressRequest);

    //couponRequest
    this.$set(request.data, 'couponRequest', this.couponRequest);
  }

  ///////////////////////////////////SET-delete receiveList///////////////////////////////////////
  public handleReceiverListDelete(no: any): void {
    this.receiverInfoContent = this.receiverInfoContent.filter((item: any): any => {
      return item.addressNo !== no;
    });
    if (this.receiverInfoContent.length === 0) {
      this.initRceciverList();
    }
    if (this.receiverInfoContent.length > 0 && this.choseReceiverNameNo === no) {
      this.choseReceiverNameNo = this.receiverInfoContent[0].addressNo;
    }
    this.deleteAddress(no);
  }
  public deleteAddress(adNo: any): void {
    const request: any = {
      pathParams: {
        addressNo: adNo,
      },
    };
    this.$api.deleteShippingAddressAddressNo(request).then((): any => {
      this.getRecentAddress();
    });
  }
  public initRceciverList(): void {
    const obj: any = {
      receiverName: '',
      receiverZipCd: '',
    };
    this.receiverInfoContent.push(obj);
    this.receiverNameTap = false;
    this.typeAddress = 'new';
  }
  public initOrderInfo(): void {
    if (this.orderInfo && this.orderInfo.ordererContact && this.orderInfo.ordererContact.ordererContact1) {
      this.phoneNum1 = this.orderInfo.ordererContact.ordererContact1.split('-')[0];
      this.phoneNum2 = this.orderInfo.ordererContact.ordererContact1.split('-')[1];
      this.phoneNum3 = this.orderInfo.ordererContact.ordererContact1.split('-')[2];
    }
    if (this.orderInfo && this.orderInfo.ordererContact && this.orderInfo.ordererContact.ordererEmail) {
      this.emailName = this.orderInfo.ordererContact.ordererEmail.split('@')[0];
      this.emailDomain = this.orderInfo.ordererContact.ordererEmail.split('@')[1];

      const domainsArr: any = this.defaultDomainsArr.map((item: any): any => {
        return item.value;
      });
      if (domainsArr.indexOf(this.emailDomain) > -1) {
        this.defaultDomain.value = this.emailDomain;
      } else {
        this.defaultDomain.value = undefined;
      }
    }
  }
  public getRecentAddress(): any {
    const request: GetShippingAddressesRecentRequest = {
      params: {
        memberNo: this.memberNo,
      },
    };
    this.$api
      .getShippingAddressesRecent(request)
      .then((res: any): any => {
        this.receiverInfoContent = [];
        this.receiverInfoContent = res.data;
        if (this.receiverInfoContent.length > 0) {
          this.receiverNameTap = true;
          this.typeAddress = 'recent';
          this.choseReceiverNameNo = this.receiverInfoContent[0].addressNo;
          this.initContact(this.choseReceiverNameNo);
        } else {
          this.initRceciverList();
        }
      })
      .catch((): any => {
        // (window as any).location.reload();
      });
  }
  public initContact(no: any): void {
    this.receiverInfoContent.map((item: any, index: number): any => {
      if (item.addressNo === no) {
        this.choseReceiverindex = index;
        this.formatterContact(item);
      }
    });
  }
  ///////////////////////////////////SET- memberType///////////////////////////////////////

  public handlememberType(ev: any, type: any): any {
    let message: any = '';
    if (type === 'MEMBER') {
      this.searchProductDisabled = true;
      message = this.$t('ORDER_MANUAL_ORDER_CONFIRM_4');
    } else {
      this.searchProductDisabled = false;
      message = this.$t('ORDER_MANUAL_ORDER_CONFIRM_5');
    }
    if (this.memberNo || this.productListContent.length > 0 || this.addProductNos) {
      if (confirm(message)) {
        this.memberNo = 0;
        this.initTopForm();
        this.searchProductDisabled = type === 'MEMBER';
      } else {
        this.searchProductDisabled = false;
        ev.preventDefault();
      }
    }
  }
  public initTopForm(): void {
    this.memberType = 'MEMBER';
    this.memberNo = 0;
    this.searchProductDisabled = true;
    this.showListView = false;
    this.showInfo = false;
    this.addProductNos = null;
    this.productListContent = [];
    this.productListView = [];
    this.freeGiftInfos = [];
    this.phoneNum1 = '010';
    this.phoneNum2 = '';
    this.phoneNum3 = '';
    this.emailName = '';
    this.emailDomain = '';
    this.emailError = false;
    this.emailErrorText = '';
    this.defaultDomain = {
      value: undefined,
    };
    this.contactError = false;
    this.contact2 = '';
    this.contact1 = '010';
    this.contact3 = '';
    this.contactTwo1 = '';
    this.contactTwo2 = '';
    this.contactTwo3 = '';
    this.deliveryMemo.value = undefined;
    this.writeMomo = false;
    this.deliveryMemoWrite = '';
    this.requireCustomsId = false;
    this.requireCustomsIdHelp = false;
    this.couponRequest = {
      cartCouponIssueNo: 0,
      deliveryCouponIssueNo: 0,
      productCoupons: [],
    };
    this.discountCouponAmt = 0;
    this.accumulationAmt = 0;
    this.removeAllCheckbox = false;
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////
  public handleShowCoupon(): void {
    if (!this.memberNo) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_15'));
      return;
    }
    (window as any).couponApplycallback = this.calculateOrderSheetAmountFromCouponPopup;
    const popupTitle: any = this.$t('ORDER_MANUAL_ORDER_COUPON_POP_TITLE');
    const title: any = this.$t('ORDER_MANUAL_ORDER_COUPON_POP_OPEN_TITLE');
    const mallNo: any = this.selectMall.mallNo;
    const url = `/order/manual-order/popup/coupon/${this.theOrderSheetNo}?callback=couponApplycallback&mallNo=${mallNo}&memberNo=${this.memberNo}&title=${popupTitle}`;
    ncpPopup(url, title, 1250, 1024);
  }
  public validateCustomsIdNumber(id: any): any {
    const customsIdNumberReg: any = /^[p|P]\d{12}$/;
    return customsIdNumberReg.test(id);
  }
  public handleShowCustomsIdHelp(): void {
    this.requireCustomsIdHelp = !this.requireCustomsIdHelp;
  }

  public searchAddress(): void {
    const title: any = this.$t('ORDER_MANUAL_ORDER_ADDRESS_POP_TITLE');
    (window as any).dataCallback = this.addressCallback;
    ncpPopup('/address/search/popup?dataCallback=dataCallback', title, 800, 820);
  }
  public addressCallback(data: any): void {
    this.receiverInfoContent[this.choseReceiverindex].receiverZipCd = data.zipCd;
    this.receiverInfoContent[this.choseReceiverindex].receiverAddress = data.roadAddress;
    this.receiverInfoContent[this.choseReceiverindex].receiverDetailAddress = data.roadAddressExtra;
    this.receiverInfoContent[this.choseReceiverindex].receiverJibunAddress = data.jibunAddress;
    
    this.calculateAmount();
  }
  public handleDefaultDomainChange(): void {
    if (this.defaultDomain.value === undefined) {
      this.emailDomain = '';
    } else {
      this.emailDomain = this.defaultDomain.value;
      this.emailError = false;
    }
    $('#emailDomain').focus();
  }
  public checkEmail(ev: any, tag: string): void {
    const text: any = $(ev.target).val();
    const korReg: any = /[ㄱ-힣]+/;
    if (korReg.test(text)) {
      this.emailName = '';
      return;
    }

    const regAll: any = /[^a-z0-9A-Z!@#$%^&+=\-_.()]/;
    let flag: any = false;

    if (regAll.test(text)) {
      this.emailErrorText = this.$t('ORDER_MANUAL_ORDER_EMAIL_ERROR_TEXT_1') as any;
      flag = true;
    } else if (text === '') {
      this.emailErrorText = this.$t('ORDER_MANUAL_ORDER_EMAIL_ERROR_TEXT_2') as any;
      flag = true;
    }

    if (tag === 'emailDomain') {
      const atIdx = text.indexOf('.');
      if (atIdx < 1 || atIdx === text.length - 1) {
        this.emailErrorText = this.$t('ORDER_MANUAL_ORDER_EMAIL_ERROR_TEXT_2') as any;
        flag = true;
      }
      const domainsArr: any = this.defaultDomainsArr.map((item: any): any => {
        return item.value;
      });
      if (domainsArr.indexOf(this.emailDomain) > -1) {
        this.defaultDomain.value = this.emailDomain;
      } else {
        this.defaultDomain.value = undefined;
      }
    }
    this.emailError = flag;
  }

  //////now//////////////////////////////////////////////SET-contact//////////////////////////////////////////////////
  public handleContactOne(): void {
    this.receiverInfoContent[this.choseReceiverindex].receiverContact1 =
      this.contact1 + '-' + this.contact2 + '-' + this.contact3;
  }
  public handleContactTwo(): void {
    this.receiverInfoContent[this.choseReceiverindex].receiverContact2 =
      this.contactTwo1 + '-' + this.contactTwo2 + '-' + this.contactTwo3;
  }
  public handleNameCheck(tag: string): void {
    const _this: any = this;
    _this[tag] = _this[tag].replace(/[\d ]/g, '');
  }
  public handlRereceiverNameCheck(tag: string): void {
    const _this: any = this;
    _this.receiverInfoContent[this.choseReceiverindex][tag] = _this.receiverInfoContent[this.choseReceiverindex][
      tag
    ].replace(/[\d ]/g, '');
  }
  public handleContactBlur(): void {
    this.contactError = false;
  }
  public phoneNumCheck(atr: string, ev?: any): void {
    const _this = this;
    const reg: any = /\D/g;
    if (atr === 'contact2') {
      if (reg.test(ev.target.value)) {
        this.contactError = true;
      } else {
        this.contactError = false;
      }
    }
    _this[atr] = _this[atr].replace(/\D/g, '');
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public getTheMalls(): any {
    const resArr = this.malls.map((item: any): any => {
      this.mallNOsArr.push(item.mallNo);
      return { option: item.mallName, value: item.mallNo };
    });
    this.theMalls = [...resArr];
    this.selectMall.mallNo = this.theMalls[0].value;
    this.beforeMallNo = this.theMalls[0].value;
    this.getAccumulationInfo();
  }

  private receivePostMessage({ data }: MessageEvent) {
    if (data?.type === 'SELECTED_MEMBER' && data?.data?.[0].memberNo) {
      // 초기화
      this.initTopForm();

      // 선택된 회원으로 업데이트
      this.memberNo = data.data[0].memberNo ?? 0;
      this.searchProductDisabled = false;
    }
  }

  public onClickSearchMemberBtn(): void {
    if (this.memberNo) {
      if (!confirm(this.$t('ORDER_MANUAL_ORDER_CONFIRM_6').toString())) {
        return;
      }
    }

    // 통합어드민의 회원조회 팝업 호출
    const popup = throwWindowPopup('MemberSearch', null, 'lg', null, null, { mallNo: this.selectMall.mallNo, checkType: 'radio' });
    popup.addEventListener('message', this.receivePostMessage);
  }

  public handleAddProduct(): void {
    if (this.showListView) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_19'));
      return;
    }
    let productNos = this.addProductNos
      .replace(/\r\n|\n/g, ',')
      .replace(/[+]/g, ',')
      .replace(/[*]/g, ',')
      .replace(/,+$/g, ',')
      .split(',');

    if (productNos.join('').replace(/\s/g, '') === '') {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_20'));
      return;
    }
    productNos = productNos.join(',');
    // 调用查询api 之后查看

    this.getProductList(productNos);
  }

  public showPorductPopup(): void {
    // this.emptyFlag = false;

    // if (!this.emptyFlag) {  //之后查看
    //   alert(this.$t('ORDER_MANUAL_ORDER_ALERT_19'));
    //   return;
    // }

    if (this.memberType === 'MEMBER' && (this.memberNo === '' || this.memberNo === null)) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_21'));
      return;
    }
    const mallNo = this.selectMall.mallNo;
    (window as any).productCallBack = this.productCallBack;
    const title: any = this.$t('ORDER_MANUAL_ORDER_PRODUCT_POP_TITLE');
    const url = `/product/search/popup?mallNo=${mallNo}&callBackName=productCallBack&&limit=${this.PRODUCT_COUNT_LIMIT}&allBtn=false`;
    ncpPopup(url, title, 1250, 1024);
  }
  ///////////////////////////////////////////////////SET-save//////////////////////////////////////////////////////////
  public handleSureOrder(): void {
    if (this.memberNo === 0 && this.memberType === 'MEMBER') {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_22'));
      return;
    }

    if (this.productListContent.length === 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_23'));
      return;
    }
    const needSelect: any = this.productListContent.filter((item: any): any => {
      return !item.select || item.select === undefined;
    }).length;
    if (needSelect > 0) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_24'));
      return;
    }
    this.formatterInputContent(this.productListContent);
    const theProducts: any = this.productListContent.map((item: any): any => {
      return {
        orderCnt: item.selectStockCnt,
        optionInputs: item.inputContent,
        optionNo: item.select,
        productNo: item.productNo,
      };
    });
    //////////////////////////////////input check///////////////////////////////
    let validInput = false;
    if (
      theProducts.forEach((product: any): any => {
        if (
          product.optionInputs.length > 0 &&
          product.optionInputs.some((input: any): any => input.inputValue === '')
        ) {
          validInput = true;
          return false;
        }
      })
    )
      if (validInput) {
        alert(this.$t('ORDER_MANUAL_ORDER_ALERT_25'));
        return;
      }
    const sheetRequest: any = {
      data: {
        memberNo: this.memberNo, //之后查看非会员传什么数值
        mallNo: this.selectMall.mallNo,
        products: theProducts,
      },
    };
    this.$api.postOrderSheets(sheetRequest).then((res: any): any => {
      const name: any = this.theAccumulationName;
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_26', { name: name }));
      this.getOrderInfo(res);


      this.showListView = true;
      this.theOrderSheetNo = '';
      this.theOrderSheetNo = res.data.orderSheetNo;
      if (this.memberNo) {
        this.getCoupons(res);
        this.getRecentAddress();
      } else {
        this.initNewAddress();
      }
    });
  }
  public formatterInputContent(arr: any): any {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      if (item.customerDemands.length === 0) {
        this.$set(item, 'inputContent', []);
      } else {
        const firstLineItem: any = arr.filter((fItem: any): any => {
          return fItem.productNo === item.productNo && fItem.firstLine;
        })[0];
        const inputArr: any = [];
        firstLineItem.customerDemands.map((fItem: any): any => {
          if (fItem.target === 'PRODUCT') {
            const obj: any = {};
            this.$set(obj, 'inputLabel', fItem.content);
            this.$set(obj, 'inputValue', fItem.inputValue);
            inputArr.push(obj);
          }
        });
        item.customerDemands.map((cItem: any): any => {
          if (cItem.target === 'OPTION') {
            const obj: any = {};
            this.$set(obj, 'inputLabel', cItem.content);
            this.$set(obj, 'inputValue', cItem.inputValue);
            inputArr.push(obj);
          }
        });

        this.$set(item, 'inputContent', inputArr);
      }
    });
  }
  public formatterTheSaveList(arr: any): any {
    if (arr.length === 0) {
      return;
    }
    const newArr: any = [];
    arr.map((item: any): any => {
      newArr.push(JSON.parse(JSON.stringify(item)));
    });
    // 判断是否需要合并customerDemands.length>0不需要
    const notCombine: any = [];
    newArr.map((item: any): any => {
      if (item.firstLine && notCombine.indexOf(item.productNo) < 0 && item.customerDemands.length) {
        notCombine.push(item.productNo);

        //  formatter item 的 customerDemands
        const products: any = [];
        item.customerDemands.map((cItem: any): any => {
          if (cItem.target === 'PRODUCT') {
            products.push(cItem);
          }
        });
        newArr.map((theItem: any): any => {
          if (theItem.productNo === item.productNo) {
            const options: any = [];
            theItem.customerDemands.map((cItem: any): any => {
              if (cItem.target === 'OPTION') {
                options.push(cItem);
              }
            });
            theItem.customerDemands = [];
            theItem.customerDemands = products.concat(options);
          }
        });
      }
    });
    //合并相同的list
    const sameItem: any = [{ productNo: 0, select: 0 }];
    const filterSameArr: any = [];
    newArr.map((item: any): any => {
      const obj: any = { productNo: item.productNo, select: item.select };
      const sameFlag: any = sameItem.filter((sItem: any): any => {
        return sItem.productNo === obj.productNo && sItem.select === obj.select;
      }).length;
      if (!sameFlag || notCombine.indexOf(item.productNo) > -1) {
        //判断是否需要合list
        sameItem.push(obj);
        filterSameArr.push(JSON.parse(JSON.stringify(item)));
      } else {
        filterSameArr.map((fItem: any): any => {
          if (fItem.productNo === item.productNo && fItem.select === item.select) {
            fItem.selectStockCnt += item.selectStockCnt;
            fItem.totalBuyAmt += item.totalBuyAmt;
          }
          if (fItem.productNo === item.productNo && fItem.firstLine) {
            fItem.theRow = fItem.theRow - 1;
          }
        });
      }
    });
    const groupArr: any = [];
    const deliveryGroups: GetOrderSheetsOrderSheetNo['deliveryGroups'] = this.orderInfo.deliveryGroups;

    filterSameArr.map((item: any): any => {
      if (item.firstLine) {
        deliveryGroups.forEach(({ orderProducts, deliveryAmt }): void => {
          orderProducts.forEach(({ productNo }: { productNo: number }): void => {
            productNo === item.productNo && this.$set(item, 'deliveryAmt', deliveryAmt);
          });
        });
      }
      this.$set(item, 'onlyOne', false);
      if (groupArr.indexOf(item.productNo) < 0) {
        groupArr.push(item.productNo);
        const onlyOne: any = filterSameArr.filter((theItem: any): any => {
          return theItem.productNo === item.productNo;
        }).length;
        if (onlyOne === 1) {
          this.$set(item, 'onlyOne', true);
        }
      }
    });
    return filterSameArr;
  }
  public initNewAddress(): void {
    const obj: any = {
      receiverName: '',
      receiverZipCd: '',
      receiverAddress: '',
      receiverDetailAddress: '',
      receiverJibunAddress: '',
    };
    this.contactTwo1 = '';
    this.contactTwo2 = '';
    this.contactTwo3 = '';
    this.contact2 = '';
    this.contact1 = '010';
    this.contact3 = '';
    this.receiverInfoContent = [];
    this.receiverInfoContent.push(obj);
  }

  public getOrderInfo(res: any): void {
    const request: GetOrderSheetsOrderSheetNoRequest = {
      pathParams: {
        orderSheetNo: res.data.orderSheetNo, //'202009280000069035'//res.data.orderSheetNo
      },
    };
    this.$api.getOrderSheetsOrderSheetNo(request).then((data): any => {
      this.orderInfo = {};
      this.orderInfo = data.data;
      this.requireCustomsId = data.data.requireCustomsIdNumber;
      this.setOrderSheetInfo(data.data);
      this.productListView = this.formatterTheSaveList(this.productListContent); // list-view
      this.theOrdererName = data.data.ordererContact ? data.data.ordererContact.ordererName : '';
      this.handleGetPaymentData(data.data);
      this.setPgTypes();
      this.initOrderInfo();
      this.showInfo = true;
      this.couponRequest = {
        cartCouponIssueNo: 0,
        deliveryCouponIssueNo: 0,
        productCoupons: [],
      };
      this.discountCouponAmt = 0;
      this.accumulationAmt = 0;

      this.freeGiftInfos = data.data.freeGiftInfos?.map((item) => ({
        ...item,
        freeGifts: item.freeGifts?.map((gift) => ({
          ...gift,
          checked: false,
        })) ?? [],
      })) ?? [];
    });
  }
  public handleShowlist(): void {
    if (confirm(this.$t('ORDER_MANUAL_ORDER_CONFIRM_7') as any)) {
      this.showListView = false;
      this.showInfo = false;
    }
  }
  ///////////////////////////////////////////////////////SET-orderInfo////////////////////////////////////////////////////////////
  public setOrderSheetInfo(resp: any): void {
    this.setOrderTitle(resp.deliveryGroups);
  }
  public setOrderTitle(deliveryGroups: any): void {
    let optionCount = 0;
    deliveryGroups.forEach((group: any): any => {
      optionCount += group.orderProducts
        .map((product: any): any => product.orderProductOptions.length)
        .reduce((prev: any, next: any): any => prev + next);
    });
    const nameUnit: any = this.$t('ORDER_MANUAL_ORDER_NAME_UNIT');
    const cntUnit: any = this.$t('ORDER_MANUAL_ORDER_CNT_NUIT');
    this.theOrderTitle = `${deliveryGroups[0].orderProducts[0].productName} ${nameUnit} ${optionCount - 1}${cntUnit}`;
  }
  ///////////////////////////////////////////////SET- paymentData////////////////////////////////////////////////////
  public handleGetPaymentData(data: any): void {
    this.paymentData = {};
    this.paymentData.productAmt = data.paymentInfo.productAmt.toLocaleString();
    this.paymentData.couponAmt = (data.paymentInfo.cartCouponAmt + data.paymentInfo.productCouponAmt).toLocaleString();
    this.paymentData.deliveryAmt = (data.paymentInfo.deliveryAmt + data.paymentInfo.remoteDeliveryAmt).toLocaleString();
    this.paymentData.usedAccumulationAmt = data.paymentInfo.usedAccumulationAmt.toLocaleString();
    this.paymentData.paymentAmt = data.paymentInfo.paymentAmt.toLocaleString();
    this.paymentData.accumulationAmt = data.paymentInfo.accumulationAmt.toLocaleString();
    this.paymentData.availableMaxAccumulationAmt = data.paymentInfo.availableMaxAccumulationAmt.toLocaleString();
  }

  public getCoupons(res: any): void {
    const couponRequest: any = {
      pathParams: {
        orderSheetNo: res.data.orderSheetNo,
      },
    };
    this.$api.getOrderSheetsOrderSheetNoCoupons(couponRequest).then((resp: any): any => {
      this.avaliableCouponCount = 0;
      const cartCouponCount = resp.data.cartCoupons ? resp.data.cartCoupons.length : 0;
      const deliveryCouponCount = resp.data.deliveryCoupons ? resp.data.deliveryCoupons.length : 0;
      const productCouponCount =
        resp.data.products.length > 0
          ? resp.data.products
              .map((product: any): any => product.productCoupons.length)
              .reduce((prev: any, next: any): any => prev + next)
          : 0;
      this.avaliableCouponCount = cartCouponCount + deliveryCouponCount + productCouponCount;
    });
  }

  public async setPgTypes(): Promise<void> {
    const request = { params: { mallNos: this.selectMall.mallNo } };

    const { data } = await this.$api.getOrderConfigsOrder(request);

    const enablePgTypes = data[0].value.enablePgTypes;

    // payTypes(결제수단)은 현재로서 제한을 두고있기 때문에 enablePayTypes를 사용하지않고 this.enablePayTypesInManualOrder를 사용한다.
    this.pgTypes = this.pgTypeMap
      .filter(pgType => this.enablePgTypesForManualOrder.includes(pgType.value))
      .filter(pgType => enablePgTypes.includes(pgType.value));
    this.pgType = this.pgTypes[0]?.value;
  }

  // public initPgTypes: any = [
  //   {value: 'DUMMY', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_DUMMY'},
  //   {value: 'PAYCO', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_PAYCO'},
  //   {value: 'PAYPAL', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_PAYPAL'},
  //   {value: 'STRIPE', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_STRIPE'},
  //   {value: 'KCP', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_KCP'},
  //   {value: 'INICIS', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_INICIS'},
  //   {value: 'NONE', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_NONE'},
  //   {value: 'KCP_MOBILE', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_KCP_MOBILE'},
  //   {value: 'KCP_APP', option: ' ORDER_MANUAL_ORDER_INIT_PA_TYPE_KCP_APP'},
  //   {value: 'NAVER_PAY', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_NAVER_PAY'},
  //   {value: 'LIIVMATE', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_LIIVMATE'},
  //   {value: 'PAYPALPRO', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_PAYPALPRO'},
  //   {value: 'ATHOR_NET', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_ATHOR_NET'},
  //   {value: 'KAKAO_PAY', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_KAKAO_PAY'},
  //   {value: 'NAVER_EASY_PAY', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_NAVER_EASY_PAY'},
  //   {value: 'LG_U_PLUS', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_LG_U_PLUS'},
  //   {value: 'VERITRANS', option: 'ORDER_MANUAL_ORDER_INIT_PA_TYPE_VERITRANS'}
  // ];
  public loadScriptString(): any {
    const payplusScript: any = $(
      '<script type="text/javascript" src="https://testpay.kcp.co.kr/plugin/payplus_web.jsp"></script>',
    ); //创建一个script标签
    const iNIStdPayScript: any = $(
      '<script type="text/javascript" src="https://stdpay.inicis.com/stdjs/INIStdPay.js"></script>',
    ); //创建一个script标签
    payplusScript.addClass('payplusScript');
    iNIStdPayScript.addClass('iNIStdPayScript');
    $('head').append(payplusScript);
    $('head').append(iNIStdPayScript);
  }
  public theDestroyedInit(): void {
    $('html')
      .find('.payplusScript')
      .remove();
    $('html')
      .find('.iNIStdPayScript')
      .remove();
  }
}
